export namespace NFiles {
  export type ModelFile = {
    Id: number;
    Name: string | null;
    Data: string | null;
    Lifetime: string | null;
    Description: string | null;
  };

  export enum ExportDataTypes {
    Records = 'Records',
    RecordsServices = 'RecordsServices',
    Clients = 'Clients',
  }

  export type ModelUserPhoto = {
    InputImage: string | null;
    InputBytes: string | null;
    NormalizedPhoto: string | null;
  };

  export type ModelPhoto = {
    UserId: number;
    ClientId: number;
    PhotoBase64: string | null;
  };

  export type ModelClientFile = {
    Id: number;
    TimeCreated: string;
    ClientId: number;
    Description: string | null;
    FileName: string | null;
    FileSize: number;
    Data: string | null;
    Extension: string | null;
    Thumbnail: string | null;
    ClientMessageId: number | null;
    // Свойства Duration в Сваггере нет, но на деле сервер (GetLeadClientActionHistory) его возвращает
    // в виде строки, а фронт использует его для рендера (на 24.10.2024). Во избежание багов ему
    // дополнительно был присвоен тип null, чтобы фронт убеждался о его заполненности перед рендером
    Duration: string | null;
    ExternalAccessId?: string | null;
  };
}
